import { merchantIcons } from '@assets/icons';
import { memo } from 'react';

import RequestStatusRow from './RequestStatusRow';

const REQUEST_STATUS_ITEMS = [
  {
    id: 'status',
    icon: merchantIcons.clockBold,
    label: 'Status',
    value: 'Under Review',
  },
  {
    id: 'review-time',
    icon: merchantIcons.calendar,
    label: 'Expected Review Time',
    value: '1-2 business days',
  },
  {
    id: 'updates',
    icon: merchantIcons.sms,
    label: 'We’ll keep you updated',
    value: 'You will receive an email notification once there’s an update',
  },
];

const RequestStatusCard = memo(() => (
  <div className="w-full overflow-hidden rounded-field bg-white">
    {REQUEST_STATUS_ITEMS.map((item, index) => (
      <RequestStatusRow
        key={item.id}
        icon={item.icon}
        label={item.label}
        value={item.value}
        showDivider={index < REQUEST_STATUS_ITEMS.length - 1}
      />
    ))}
  </div>
));

RequestStatusCard.displayName = 'RequestStatusCard';

export default RequestStatusCard;
